import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';

import GenericSelection from '../../../Common/GenericSelection';
import { isLMH, isSDR, isCRW, isOLG } from '../../../../actions/root_url';

const propTypes = {
  minPurchasePrice: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  promoCode: PropTypes.string,
  autoApply: PropTypes.bool,
  IsOneTime: PropTypes.bool,
  editing: PropTypes.bool,
  productQuantityB: PropTypes.string,
  SalesType: PropTypes.string,
  handleTextInputChange: PropTypes.func,
  handleCheckBoxChange: PropTypes.func,
};

const defaultProps = {
  minPurchasePrice: '',
  productQuantityB: '',
  promoCode: '',
  autoApply: true,
  IsOneTime: false,
  editing: false,
  SalesType: 'all',
  handleTextInputChange: () => { },
  handleCheckBoxChange: () => { },
  handleSelectionChange: () => { },
};


const ByTotalPriceProductFields = ({
  minPurchasePrice,
  productQuantityB,
  promoCode,
  autoApply,
  IsOneTime,
  editing,
  SalesType,
  handleTextInputChange,
  handleCheckBoxChange,
  handleSelectionChange,
}) => {
  const salesTypeOptions = [
    { label: <Translate value="all" />, value: 'all' },
    { label: <Translate value="wholesale" />, value: 'wholesale' },
    { label: <Translate value="retail" />, value: 'retail' },
  ];
  return (
    <div className="promo-fields">

      <div className="method-selection">
        <GenericSelection
          translation={<Translate value="sales_type" />}
          setSelected={({ value }) => handleSelectionChange(value, 'SalesType')}
          value={SalesType}
          options={salesTypeOptions}
          colon
        />
      </div>

      <div className="flex-row">
        <label htmlFor="total-price-product" className="field-margin"><Translate value="min_purchase_amount" />:</label>
        <input
          id="min-purchase-text-input"
          name="minPurchasePrice"
          className="text-input-field"
          type="text"
          value={minPurchasePrice}
          onChange={handleTextInputChange}
        />
      </div>
      <div className="flex-row">
        <label htmlFor="prod-qty-B" className="field-margin"><Translate value="gift_quantity" />:</label>
        <input
          id="min-purchase-text-input"
          name="productQuantityB"
          className="text-input-field"
          type="text"
          value={productQuantityB}
          onChange={handleTextInputChange}
        />
      </div>
      {/* <div className="total-price-product-discount">
        <label htmlFor="discount" className="field-margin"><Translate value="discount" />:</label>
        <label htmlFor="discount-free"><Translate value="free" /></label>
      </div> */}
      {
        editing &&
        <div className="flex-row">
          <label htmlFor="prod-qty-B" className="field-margin"><Translate value="promo_code" />:</label>
          <input
            id="promo-code-text-input-edit"
            name="promoCode"
            className="text-input-field"
            type="text"
            value={promoCode}
            onChange={handleTextInputChange}
          />
        </div>
      }
      {
        editing &&
        <div className="flex-row">
          <label htmlFor="prod-qty-B" className="field-margin"><Translate value="auto_apply" />:</label>
          <input
            id="auto-apply-checkbox-edit"
            name="autoApply"
            type="checkbox"
            disabled={(isOLG || isLMH || isSDR || isCRW) && IsOneTime}
            checked={autoApply}
            onChange={handleCheckBoxChange}
          />
        </div>
      }
      {
        (isOLG || isLMH || isSDR || isCRW) && editing &&
        <div className="flex-row">
          <label htmlFor="prod-qty-B" className="field-margin"><Translate value="one_time_use" />:</label>
          <input
            id="one-time-checkbox-edit"
            name="IsOneTime"
            type="checkbox"
            checked={IsOneTime}
            onChange={handleCheckBoxChange}
          />
        </div>
      }
    </div>
  );
}

ByTotalPriceProductFields.propTypes = propTypes;
ByTotalPriceProductFields.defaultProps = defaultProps;

export default ByTotalPriceProductFields;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/PromotionsPage/components/ByTotalPriceProductFields.jsx